import request from './request';
import requestWithoutTimeout from './requestWithoutTimeout';

const productService = {
  // =========================
  // GETTERS
  // =========================
  getAll: (params) =>
    request.get('dashboard/admin/products/paginate', { params }),

  getById: (id, params) =>
    request.get(`dashboard/admin/products/${id}`, { params }),

  export: (params) =>
    requestWithoutTimeout.get(`dashboard/admin/products/export`, { params }),

  import: (data) =>
    requestWithoutTimeout.post('dashboard/admin/products/import', data),

  // =========================
  // CREATE / UPDATE (NO FILE)
  // =========================
  create: (params) =>
    request.post(`dashboard/admin/products`, params),

  update: (uuid, params) =>
    request.put(`dashboard/admin/products/${uuid}`, params),

  // =========================
  // CREATE WITH FILE
  // =========================
  createWithFile: (data, config = {}) => {
    // If caller already passed a FormData (the form builds it), use it directly
    if (typeof FormData !== 'undefined' && data instanceof FormData) {
      let shopId = data.get('shop') ?? data.get('shop_id');
      if (typeof shopId === 'string') {
        const s = shopId.trim();
        shopId = s && s !== 'undefined' && s !== 'null' ? s : null;
      }
      data.delete('shop_id');
      if (shopId !== null && shopId !== undefined && shopId !== '') {
        data.append('shop_id', shopId);
      }
      return request.post(`dashboard/admin/products`, data, {
        ...config,
      });
    }

    const formData = new FormData();

    // ⭐ shop_id إجباري
    formData.append(
      'shop_id',
      data?.shop?.value ?? data?.shop_id
    );

    Object.keys(data || {}).forEach((key) => {
      if (key === 'shop') return;
      if (data[key] === undefined || data[key] === null) return;

      // audio = File فقط
      if (key === 'audio') {
        if (data[key] instanceof File) {
          formData.append('audio', data[key]);
        }
        return;
      }

      formData.append(key, data[key]);
    });

    return request.post(`dashboard/admin/products`, formData, {
      ...config,
    });
  },

  // =========================
  // UPDATE WITH FILE
  // =========================
  updateWithFile: (uuid, data, config = {}) => {
    // If caller already passed a FormData, ensure shop id exists and use it
    if (typeof FormData !== 'undefined' && data instanceof FormData) {
      let shopId = data.get('shop') ?? data.get('shop_id');
      if (typeof shopId === 'string') {
        const s = shopId.trim();
        shopId = s && s !== 'undefined' && s !== 'null' ? s : null;
      }
      data.delete('shop_id');
      if (shopId !== null && shopId !== undefined && shopId !== '') {
        data.append('shop_id', shopId);
      }
      // Some servers (PHP) don't parse multipart body on PUT — use POST with _method=PUT
      if (!data.get('_method')) {
        data.append('_method', 'PUT');
      }
      return request.post(`dashboard/admin/products/${uuid}`, data, {
        ...config,
      });
    }

    const formData = new FormData();

    // ⭐ shop_id لازم يتبعت دايمًا
    formData.append(
      'shop_id',
      data?.shop?.value ?? data?.shop_id
    );

    Object.keys(data || {}).forEach((key) => {
      if (key === 'shop') return;
      if (data[key] === undefined || data[key] === null) return;

      // audio = File فقط (لو المستخدم اختار ملف جديد)
      if (key === 'audio') {
        if (data[key] instanceof File) {
          formData.append('audio', data[key]);
        }
        return;
      }

      formData.append(key, data[key]);
    });

    // Use POST with _method=PUT so PHP parses multipart form-data correctly
    if (!formData.get('_method')) {
      formData.append('_method', 'PUT');
    }
    return request.post(`dashboard/admin/products/${uuid}`, formData, {
      ...config,
    });
  },

  // =========================
  // DELETE & OTHER ACTIONS
  // =========================
  delete: (params) =>
    request.delete(`dashboard/admin/products/delete`, { params }),

  dropAll: () =>
    request.get(`dashboard/admin/products/drop/all`),

  restoreAll: () =>
    request.get(`dashboard/admin/products/restore/all`),

  extras: (uuid, data) =>
    request.post(`dashboard/admin/products/${uuid}/extras`, data),

  stocks: (uuid, data) =>
    request.post(`dashboard/admin/products/${uuid}/stocks`, data),

  properties: (uuid, data) =>
    request.post(`dashboard/admin/products/${uuid}/properties`, data),

  setActive: (uuid) =>
    request.post(`dashboard/admin/products/${uuid}/active`, {}),

  getStock: (params) =>
    request.get(`dashboard/admin/stocks/select-paginate`, { params }),

  updateStatus: (uuid, params) =>
    request.post(
      `dashboard/admin/products/${uuid}/status/change`,
      {},
      { params },
    ),
};

export default productService;
